import { useData } from '../lib/data.jsx';
import { useUI, Sec, Row, Pimg } from '../lib/ui.jsx';
import { B, thDate, todayISO } from '../lib/util.js';

function statusChip(c) {
  if (c.over_days > 0) return <span className="chip c-over">เกิน {c.over_days} วัน</span>;
  if (c.to_date === todayISO()) return <span className="chip c-due">ครบวันนี้</span>;
  return <span className="chip c-out">กำลังเช่า</span>;
}

export default function Home({ go }) {
  const { openContracts, credits, itemsOf, loaded, err } = useData();
  const { openDrawer, closeDrawer } = useUI();

  const activeCredits = credits.filter(c => c.status === 'active');
  const due = openContracts.filter(c => c.to_date === todayISO() && c.over_days <= 0);
  const over = openContracts.filter(c => c.over_days > 0);
  const sorted = [...openContracts].sort((a, b) => (b.over_days - a.over_days) || (a.to_date < b.to_date ? -1 : 1));

  const openContract = (c) => {
    const items = itemsOf(c.id);
    openDrawer('สัญญาเช่า · ' + c.contract_no, c.customer_name, (<>
      <Sec>สัญญา</Sec>
      <Row k="สถานะ" v={c.over_days > 0 ? `เกินกำหนด ${c.over_days} วัน` : 'กำลังเช่า'} gold={c.over_days > 0} />
      <Row k="กำหนดคืน" v={thDate(c.to_date)} />
      <Row k="ค่าเช่า (รวม VAT)" v={B(c.net_rent) + ' ฿'} />
      <Row k="มัดจำที่ถือไว้" v={B(c.deposit) + ' ฿'} gold />
      {Number(c.wht) > 0 && <Row k="ถูกหัก ณ ที่จ่าย" v={B(c.wht) + ' ฿'} />}
      <Sec>อุปกรณ์ ({items.length} ชิ้น)</Sec>
      {items.map(it => (
        <div className="dw-item" key={it.id}>
          <div className="pthumb"><Pimg cat={it.category} size={34} image={it.image_url} /></div>
          <div><div className="n">{it.name_snapshot} · {it.unit_code}</div>
            <div className="s">{it.sku} · มัดจำ {B(it.deposit_amount)}</div></div>
        </div>
      ))}
      <div className="dw-act">
        <button onClick={() => { closeDrawer(); go('return'); }}>รับคืน / ตรวจสภาพ <span className="ar">→</span></button>
      </div>
    </>));
  };

  return (<>
    <div className="pagehead">
      <div className="eyebrow">ภาพรวม · OVERVIEW</div>
      <h1 className="bighead">ระบบเช่า<br />และรับเทิร์นอุปกรณ์</h1>
      <p className="lede">จัดการสัญญาเช่า การรับคืน เครดิตเช่าเพื่อซื้อ และการรับเทิร์นอุปกรณ์ ครบในระบบเดียว</p>
    </div>
    {err && <div className="note show" style={{ marginBottom: 16 }}>โหลดข้อมูลไม่สำเร็จ: {err}</div>}
    <div className="statbox" style={{ marginBottom: 22 }}>
      <div className="stat"><div className="k">สัญญาที่ปล่อยอยู่ · OUT</div><div className="v">{loaded ? openContracts.length : '—'}</div></div>
      <div className="stat warn"><div className="k">ครบกำหนดวันนี้ · DUE</div><div className="v">{loaded ? due.length : '—'}</div></div>
      <div className="stat bad"><div className="k">เกินกำหนด · OVERDUE</div><div className="v">{loaded ? over.length : '—'}</div></div>
      <div className="stat ok"><div className="k">เครดิตรอใช้ · CREDIT</div><div className="v">{loaded ? activeCredits.length : '—'}</div></div>
    </div>
    <div className="card">
      <h2>สัญญาที่ต้องติดตาม</h2>
      <div className="hint">เรียงตามความเร่งด่วน — เกินกำหนดก่อน แล้วครบกำหนดวันนี้</div>
      <table>
        <thead><tr>
          <th>สัญญา</th><th>ลูกค้า</th><th>รายการ</th><th>กำหนดคืน</th><th>สถานะ</th><th className="r">มัดจำ</th><th></th>
        </tr></thead>
        <tbody>
          {sorted.map(c => (
            <tr key={c.id} className="clickrow" onClick={() => openContract(c)}>
              <td className="mono">{c.contract_no}</td>
              <td>{c.customer_name}</td>
              <td>{itemsOf(c.id).length} ชิ้น</td>
              <td className="mono">{thDate(c.to_date)}</td>
              <td>{statusChip(c)}</td>
              <td className="r mono">{B(c.deposit)}</td>
              <td className="r"><button className="btn ghost sm"
                onClick={(e) => { e.stopPropagation(); go('return'); }}>รับคืน</button></td>
            </tr>
          ))}
          {!sorted.length && <tr><td colSpan={7} className="empty">ไม่มีสัญญาค้าง — เปิดสัญญาใหม่ได้จากแท็บ "เปิดสัญญาเช่า"</td></tr>}
        </tbody>
      </table>
    </div>
  </>);
}
